import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-source-control-management-settings',
  templateUrl: './source-control-management-settings.component.html',
  styleUrls: ['./source-control-management-settings.component.scss']
})
export class SourceControlManagementSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
